module.exports = __webpack_public_path__ + "static/media/ARM_down_03.6fe42236.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/arm/ARM_down_03.png
// module id = 289
// module chunks = 0